<template>
  <BaseLoading  opaque :spinning="changePasswordLoading">
  <div>
    <header class="inner-banner">
      <div class="container">
        <div class="row">
          <div class="inner-wrapper">
            <div class="col-md-12">
              <!-- Login -->
              <div class="container">
                <div class="card card-container">
                  <a href="/">
                    <img src="/images/logo.png" alt="Logo" class="text-center" />
                  </a>
                  <div class="coach-verifcation-form">
                    <h2 style="padding: 10px 0 20px;">Reset Password</h2>
                  </div>
                  <BaseInput
                    :value="newPassword"
                    placeholder="Enter new password"
                    style="margin-bottom: 15px"
                    type="password"
                    @change="(event) => handlePasswordInput(event, 'newPassword')"
                  />
                  <div class="custom-font-size">
                    <p>Passwords should be at least 8 characters long</p>
                  </div>
                  <BaseInput
                    :value="confirmPassword"
                    placeholder="Confirm password"
                    style="margin-bottom: 25px"
                    type="password"
                    @change="(event) => handlePasswordInput(event, 'confirmPassword')"
                  />
                  <div class="column-flex-wrapper">
                    <BaseButton 
                      type="primary" 
                      @click="handlePasswordChange"
                    >
                      Save
                    </BaseButton>
                    <BaseButton 
                      type="text"
                      class="pointer-hover" 
                      @click="handleLogin"
                    >
                      Back to Login
                    </BaseButton >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
  </BaseLoading>
</template>

<script>
import { mapGetters } from "vuex";
import { User } from "@/models";
import { FormModel } from "ant-design-vue";

const USER_STORE_KEY = "userStore";

export default {
  data() {
    return {
      newPassword: "",
      confirmPassword: "",
      form: this.$form.createForm(this),
      validationRules: User.validationRules,
    };
  },
  components: {
    FormModel
  },
  computed: {
    ...mapGetters({
      changePassword: `${USER_STORE_KEY}/changePassword`,
      changePasswordLoading: `${USER_STORE_KEY}/changePasswordLoading`
    })
  },
  async created() {
    this.$store.dispatch(`${USER_STORE_KEY}/checkToken`, { token: this.$route.params.token }).then(() => {}).catch(err => {
      if(err.response.status === 400) {
            this.$router.push({ path: '/change-password/invalid/redirect' })
          }
      throw err;
    })
  },
  methods: {
    handlePasswordInput(event, type) {
      this[type] = event.target.value
    },
    async handlePasswordChange() {
      if (
        !this.newPassword ||
        !this.confirmPassword
      ){
        this.$notification.error({
          message: "Error",
          description: "Please fill both the fields"
        });
        return;
      }
      let data = {
        token: this.$route.params.token,
        password: this.newPassword,
        passwordConfirm: this.confirmPassword
      };
      if (this.newPassword != this.confirmPassword) {
        this.$notification.error({
          message: "Error",
          description: "New passwords do not match"
        });
      } else {
        this.$store.dispatch(`${USER_STORE_KEY}/resetTokenPassword`, data).then(() => {
          this.clearFields();
          this.$notification.success({
            message: "Password Changed Sucessfully",
          });
          this.$router.push("/login");
        }).catch(err => {
          if(err.response.status === 400) {
            this.$router.push({ path: '/change-password/invalid/redirect' })
          }
          throw err;
        })
        
      }
    },
    handleLogin() {
      this.$router.push('/login')
    },
    clearFields() {
      this.confirmPassword = null;
      this.newPassword = null;
    }
  }
};
</script>

<style lang="sass" scoped>
.custom-font-size
  font-size: 13px
  color: black
.column-flex-wrapper
  display: flex
  flex-direction: column
  /deep/
    button
      margin-bottom: 10px
      border-radius: 5px
.steps-content
  text-align: -webkit-center
  .general-form-wrap
    padding: 2rem
  .input-wrapper
    display: flex
    justify-content: center
    padding: 40px 40px
    border-radius: 6px
    background: #f0f0f0
    border: 1px dashed #e9e9e9
    .ant-form-horizontal
      width: 35rem
</style>
